import { WarningAlt } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";
import ReactRouterPrompt from "react-router-prompt";

import AlertDialog from "../../../../components/alertDialog/AlertDialog";

interface LeaveNewOrderAlertDialogProps {
  enableListener: boolean;
}

const LeaveNewOrderAlertDialog = (props: LeaveNewOrderAlertDialogProps) => {
  const { t } = useTranslation();

  const { enableListener } = props;

  return (
    <ReactRouterPrompt when={enableListener}>
      {({ isActive, onConfirm, onCancel }) => (
        <AlertDialog
          description={t("leaveNewOrderAlertDialogDescription")}
          handleConfirm={onConfirm}
          headerLogo={<WarningAlt size={32} />}
          showDialog={isActive}
          title={t("leaveNewOrder") + "?"}
          handleCancel={onCancel}
          type={"warning"}
        />
      )}
    </ReactRouterPrompt>
  );
};

export default LeaveNewOrderAlertDialog;
